"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodeIconSVG = void 0;

var _server = _interopRequireDefault(require("react-dom/server"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * encodeIconSVG
 * Takes a React SVG Component (like a DLS Icon) and outputs a URL-encoded
 * string so the component can be used in CSS properties like
 * `background-image`
 * @param {ReactComponent} data
 * Logic adapted from https://github.com/yoksel/url-encoder
 */
var encodeIconSVG = function encodeIconSVG(data) {
  var symbols = /[\r\n%#()<>?[\\\]^`{|}]/g;
  data = _server.default.renderToString(data);
  data = data.replace(/"/g, "'");
  data = data.replace(/>\s{1,}</g, '><');
  data = data.replace(/\s{2,}/g, ' ');

  if (data.indexOf('http://www.w3.org/2000/svg') < 0) {
    data = data.replace(/<svg/g, "<svg xmlns='http://www.w3.org/2000/svg'");
  }

  data = data.replace(symbols, encodeURIComponent);
  return data;
};

exports.encodeIconSVG = encodeIconSVG;